import { render, staticRenderFns } from "./PacketChoiceTab.vue?vue&type=template&id=7bb57acd&scoped=true"
import script from "./PacketChoiceTab.vue?vue&type=script&lang=js"
export * from "./PacketChoiceTab.vue?vue&type=script&lang=js"
import style0 from "./PacketChoiceTab.vue?vue&type=style&index=0&id=7bb57acd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb57acd",
  null
  
)

export default component.exports